import React, { Component } from 'react';
import { Alert } from 'reactstrap';

class NoDataAlert extends Component {
  render() {
    return (
      <div className="p-3">
        {this.props.noResults &&
        <Alert color="info">
          <strong>Nerasta rezultatų. </strong>
          Bandykite dar kartą. Daugiau sužinoti galite puslapyje{' '}
          <a href="/paieska/apie">Apie paiešką</a>.
        </Alert>
        }
      </div>
    );
  }
}

export default NoDataAlert;
